module.exports = __webpack_public_path__ + "img/customer_design_6.1c5870a.jpg";